import { render, staticRenderFns } from "./boxTransformer.vue?vue&type=template&id=4420a49a&scoped=true&"
import script from "./boxTransformer.vue?vue&type=script&lang=js&"
export * from "./boxTransformer.vue?vue&type=script&lang=js&"
import style0 from "./boxTransformer.vue?vue&type=style&index=0&id=4420a49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4420a49a",
  null
  
)

export default component.exports